var map = {
	"./ArrowDownIcon.tsx": 1002,
	"./ArrowLeftIcon.tsx": 961,
	"./ArrowRightIcon.tsx": 863,
	"./ArrowUpIcon.tsx": 1003,
	"./BackIcon.tsx": 1004,
	"./BurgerIcon.tsx": 1005,
	"./CalenderIcon.tsx": 1006,
	"./CloseIcon.tsx": 962,
	"./EditIcon.tsx": 1007,
	"./EmailIcon.tsx": 1008,
	"./FacebookIcon.tsx": 1009,
	"./InfoIcon.tsx": 1010,
	"./InstagramIcon.tsx": 1011,
	"./LinkedInIcon.tsx": 1012,
	"./LockIcon.tsx": 1013,
	"./PensamIcon.tsx": 1014,
	"./PiggybankIcon.tsx": 1015,
	"./PinterestIcon.tsx": 1016,
	"./PlayIcon.tsx": 1017,
	"./SearchIcon.tsx": 1018,
	"./SmallCloseIcon.tsx": 1019,
	"./TwitterIcon.tsx": 1020,
	"./UmbrellaIcon.tsx": 1021,
	"./UniversityIcon.tsx": 1022,
	"./UnlockIcon.tsx": 1023
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1001;